import { useState, useEffect } from 'react';
import { IContentItem, IContentItemElements, createDeliveryClient } from "@kontent-ai/delivery-sdk";
import { ENVIRONMENT_ID } from "../config";
import { generateSlug } from "../utils";

const client = createDeliveryClient({
  environmentId: ENVIRONMENT_ID,
});

const useKontentServiceApi = (identifier: string, isSlug = false, contentType = 'portfolio_info') => {
  const [data, setData] = useState<IContentItem<IContentItemElements> | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const [errorCode, setErrorCode] = useState<number>(0);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        let response;
        
        if (isSlug) {
          // If it's a slug, we need to find the item by matching the slug
          const allItems = await client.items<any>()
            .type(contentType)
            .toPromise();
          
          const matchingItem = allItems.data.items.find((item: any) => {
            const title = item.elements?.title?.value?.replace(/(<([^>]+)>)/gi, "");
            const itemSlug = generateSlug(title);
            return itemSlug === identifier;
          });
          
          if (matchingItem) {
            response = { data: { item: matchingItem } };
          } else {
            throw new Error('Item not found');
          }
        } else {
          // If it's a codename, fetch directly
          response = await client.item(identifier).toPromise();
        }
        
        setData(response.data.item);        
      } catch (err: any) {
        // console.error('Error fetching content items:', err);        
        setError(err as Error);
        setErrorCode(err.errorCode || 100);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [identifier, isSlug, contentType]);

  return { data, loading, error, errorCode };
};

export default useKontentServiceApi;
